import Pubnub from 'pubnub';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { RootState } from '../..';
import { getErrorText } from './helpers';

export const sendSignal = createAsyncThunk<Pubnub.SignalResponse, Pubnub.SignalParameters, { rejectValue: string }>(
  'pubnub/sendSignal',
  async (data, { rejectWithValue, getState }) => {
    try {
      const pubnubReducer = (getState() as RootState).pubnub;

      if (pubnubReducer.pubnub) {
        const result = await pubnubReducer.pubnub.signal({
          channel: data.channel,
          message: data.message,
        });

        return result;
      } else {
        throw new Error('PubnubInstanceIsNull');
      }
    } catch (e) {
      return rejectWithValue(getErrorText(e as Error));
    }
  },
);
